'use client';
import './style.sass';

import TitleCase from 'components/features/cases/NextComponents/cases/moscow-exchange/title-case';
import React from 'react';
import { getAdjacentCase } from 'shared/utilities/GetAdjacentCase/getAdjacentCase';

import Challenges from '~/components/features/cases/NextComponents/cases/moscow-exchange/challenges';
import LayoutPage from '~/components/features/cases/NextComponents/cases/moscow-exchange/layout-page';
import Results from '~/components/features/cases/NextComponents/cases/moscow-exchange/results';
import Solution from '~/components/features/cases/NextComponents/cases/moscow-exchange/solution';
import Target from '~/components/features/cases/NextComponents/cases/moscow-exchange/target';
import Team from '~/components/features/cases/NextComponents/cases/moscow-exchange/team';
import BannerCase from '~/components/features/cases/NextComponents/cases-sections/BannerCase';
import NextCase from '~/components/features/cases/NextComponents/cases-sections/NextCase';

import {
    bannerInfo,
    challengesList,
    commonResultsList,
    crewList,
    listSteps,
    resultsList,
    solutionsList,
} from './constants';

const MoscowExchange = () => {
    const { title, subtitle, descriptions, companyInfo, img } = bannerInfo;
    const casePathname = '/cases/marketing/moscow-exchange';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section>
            <BannerCase img={img} isCase={true} />
            <TitleCase
                title={title}
                subtitle={subtitle}
                descriptions={descriptions}
                companyInfo={companyInfo}
            />
            <Target />
            <LayoutPage />
            <Solution solutionsList={solutionsList} listSteps={listSteps} />
            <Challenges challengesList={challengesList} />
            <Results resultsList={resultsList} commonResultsList={commonResultsList} />
            <Team crewList={crewList} />
            {adjacentCase && (
                <NextCase
                    NextCase={{
                        nextCaseTitle: adjacentCase.case.title,
                        nextCaseImg: adjacentCase.case.image,
                        nextCaseLink: adjacentCase.case.router,
                        nextCaseText: adjacentCase.case.description,
                    }}
                />
            )}
        </section>
    );
};

export default MoscowExchange;
